function isTruthyFlag(value: unknown): boolean {
  if (value === true || value === 1) {
    return true;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
  }
  return false;
}

/** Show Add GST / GSTIN invoice only when PAN, route, and selected GSTIN are present. */
export function canAddGstDetails(userData: unknown): boolean {
  if (!userData || typeof userData !== 'object') {
    return false;
  }
  const profile = (userData as { verification_profile?: Record<string, unknown> })
    .verification_profile;
  if (!profile) {
    return false;
  }
  return (
    isTruthyFlag(profile['pan_verified']) &&
    isTruthyFlag(profile['route_verified']) &&
    !!String(profile['selected_gstin'] || '').trim()
  );
}

/**
 * Checks if the user is verified and active to place orders.
 * Order placement is strictly prohibited if:
 * - verification_profile.is_active is not true (e.g. false, null, undefined)
 * - user.is_active is false
 * - pan_verified is not true
 * - route is not verified
 */
export function canPlaceOrder(profile: any): boolean {
  if (!profile || typeof profile !== 'object') {
    return false;
  }
  const data = profile?.data || profile;
  const verification =
    data?.verification_profile ||
    data?.verification ||
    profile?.verification_profile ||
    profile?.verification ||
    data;

  if (!verification || typeof verification !== 'object') {
    return false;
  }

  // Verification profile MUST be active
  if (!isTruthyFlag(verification['is_active'])) {
    return false;
  }

  // User account (if present) MUST be active
  if (data['is_verified'] !== undefined && !isTruthyFlag(data['is_verified'])) {
    return false;
  }

  // PAN MUST be verified
  if (!isTruthyFlag(verification['pan_verified'])) {
    return false;
  }

  // Route MUST be verified
  const isRouteVerified =
    isTruthyFlag(verification['route_verified']) ||
    isTruthyFlag(verification['is_gst_verified']) ||
    isTruthyFlag(verification['is_uam_verified']) ||
    isTruthyFlag(verification['is_shop_license_verified']);

  return isRouteVerified;
}

